import DfProperty from "@/vue/domain/content/df-property";

export default class DfBrand {
  private _identifier: string;
  private _alias: string;
  private _description: string;
  private _notes: string;
  private _properties: Array<DfProperty>;
  private _dealer: any = {};
  private _storeBrand: any = {};

  constructor(
    identifier: string,
    alias: string,
    description: string,
    notes: string,
    properties: Array<DfProperty>,
    dealer: any,
    storeBrand: any
  ) {
    this._identifier = identifier;
    this._alias = alias;
    this._description = description;
    this._notes = notes;
    this._properties = properties;
    this._dealer = dealer;
    this._storeBrand = storeBrand;
  }

  get identifier(): string {
    return this._identifier;
  }

  set identifier(identifier: string) {
    this._identifier = identifier;
  }

  get alias(): string {
    return this._alias;
  }

  set alias(alias: string) {
    this._alias = alias;
  }

  get description(): string {
    return this._description;
  }

  set description(description: string) {
    this._description = description;
  }

  get notes(): string {
    return this._notes;
  }

  set notes(notes: string) {
    this._notes = notes;
  }

  get properties(): Array<DfProperty> {
    return this._properties;
  }

  set properties(properties: Array<DfProperty>) {
    this._properties = properties;
  }

  get dealer(): any {
    return this._dealer;
  }

  set dealer(dealer: any) {
    this._dealer = dealer;
  }

  get storeBrand(): any {
    return this._storeBrand;
  }

  set storeBrand(storeBrand: any) {
    this._storeBrand = storeBrand;
  }
}
